export var MODULE_BASE_PATH = '/contact';
export var PAGE_SIZE = 10;
export default {
  MODULE_BASE_PATH: MODULE_BASE_PATH,
  PAGE_SIZE: PAGE_SIZE
};